import React from "react";

const TimerContext = React.createContext({
    timer: 0,
    resetTimer: () => { },
    countDown: () => { }
})

export default TimerContext;